export default "__VITE_PUBLIC_ASSET__a4ac9b50__"